/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedDocumentTestRouteImport } from './routes/_authenticated/document-test'
import { Route as AuthenticatedInspectionsRouteImport } from './routes/_authenticated/inspections'
import { Route as AuthenticatedIssuesRouteImport } from './routes/_authenticated/issues'
import { Route as AuthenticatedLeasingRouteImport } from './routes/_authenticated/leasing'
import { Route as AuthenticatedRemindersRouteImport } from './routes/_authenticated/reminders'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedVehiclesRouteImport } from './routes/_authenticated/vehicles'
import { Route as AuthenticatedWorkOrdersRouteImport } from './routes/_authenticated/work-orders'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as AuthenticatedLeasingIndexRouteImport } from './routes/_authenticated/leasing/index'
import { Route as AuthenticatedLeasingAnalyticsRouteImport } from './routes/_authenticated/leasing/analytics'
import { Route as AuthenticatedLeasingBillingRouteImport } from './routes/_authenticated/leasing/billing'
import { Route as AuthenticatedLeasingContractsRouteImport } from './routes/_authenticated/leasing/contracts'
import { Route as AuthenticatedLeasingLeasedVehiclesRouteImport } from './routes/_authenticated/leasing/leased-vehicles'
import { Route as AuthenticatedLeasingOrderPipelineRouteImport } from './routes/_authenticated/leasing/order-pipeline'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsFleetRouteImport } from './routes/_authenticated/settings_.fleet'
import { Route as AuthenticatedSettingsInspectionsRouteImport } from './routes/_authenticated/settings_.inspections'
import { Route as AuthenticatedSettingsMaintenanceRouteImport } from './routes/_authenticated/settings_.maintenance'
import { Route as AuthenticatedSettingsTenantProfileRouteImport } from './routes/_authenticated/settings_.tenant-profile'
import { Route as AuthenticatedSettingsTerritoriesRouteImport } from './routes/_authenticated/settings_.territories'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings_.users'
import { Route as AuthenticatedVehiclesVehicleIdRouteImport } from './routes/_authenticated/vehicles_.$vehicleId'
import { Route as AuthenticatedVehiclesAddRouteImport } from './routes/_authenticated/vehicles_.add'
import { Route as AuthenticatedWorkOrdersWorkOrderIdRouteImport } from './routes/_authenticated/work-orders_.$workOrderId'
import { Route as AuthenticatedLeasingContractsContractIdRouteImport } from './routes/_authenticated/leasing/contracts_.$contractId'
import { Route as AuthenticatedLeasingContractsNewRouteImport } from './routes/_authenticated/leasing/contracts_.new'
import { Route as AuthenticatedSettingsFleetIndexRouteImport } from './routes/_authenticated/settings_.fleet/index'
import { Route as AuthenticatedSettingsFleetEnergySourcesRouteImport } from './routes/_authenticated/settings_.fleet/energy-sources'
import { Route as AuthenticatedSettingsFleetExpenseCategoriesRouteImport } from './routes/_authenticated/settings_.fleet/expense-categories'
import { Route as AuthenticatedSettingsFleetVehicleGroupsRouteImport } from './routes/_authenticated/settings_.fleet/vehicle-groups'
import { Route as AuthenticatedSettingsFleetVehicleMakesRouteImport } from './routes/_authenticated/settings_.fleet/vehicle-makes'
import { Route as AuthenticatedSettingsFleetVehicleModelsRouteImport } from './routes/_authenticated/settings_.fleet/vehicle-models'
import { Route as AuthenticatedSettingsFleetVehicleOwnershipsRouteImport } from './routes/_authenticated/settings_.fleet/vehicle-ownerships'
import { Route as AuthenticatedSettingsFleetVehicleTypesRouteImport } from './routes/_authenticated/settings_.fleet/vehicle-types'
import { Route as AuthenticatedSettingsLocationsLocationIdRouteImport } from './routes/_authenticated/settings_.locations.$locationId'
import { Route as AuthenticatedSettingsMaintenanceIndexRouteImport } from './routes/_authenticated/settings_.maintenance/index'
import { Route as AuthenticatedSettingsMaintenanceGeneralRouteImport } from './routes/_authenticated/settings_.maintenance/general'
import { Route as AuthenticatedSettingsMaintenanceServiceOperationsRouteImport } from './routes/_authenticated/settings_.maintenance/service-operations'
import { Route as AuthenticatedSettingsMaintenanceServicePlansRouteImport } from './routes/_authenticated/settings_.maintenance/service-plans'
import { Route as AuthenticatedSettingsTenantProfileIndexRouteImport } from './routes/_authenticated/settings_.tenant-profile/index'
import { Route as AuthenticatedSettingsTenantProfileGeneralRouteImport } from './routes/_authenticated/settings_.tenant-profile/general'
import { Route as AuthenticatedSettingsTenantProfileModulesRouteImport } from './routes/_authenticated/settings_.tenant-profile/modules'
import { Route as AuthenticatedSettingsTenantProfileOwnerRouteImport } from './routes/_authenticated/settings_.tenant-profile/owner'
import { Route as AuthenticatedSettingsTenantProfilePoolTypesRouteImport } from './routes/_authenticated/settings_.tenant-profile/pool-types'
import { Route as AuthenticatedSettingsTerritoriesIndexRouteImport } from './routes/_authenticated/settings_.territories.index'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdRouteImport } from './routes/_authenticated/settings_.territories.$territoryId'
import { Route as AuthenticatedVehiclesVehicleIdIndexRouteImport } from './routes/_authenticated/vehicles_.$vehicleId/index'
import { Route as AuthenticatedVehiclesVehicleIdAcquisitionRouteImport } from './routes/_authenticated/vehicles_.$vehicleId/acquisition'
import { Route as AuthenticatedVehiclesVehicleIdIdentityRouteImport } from './routes/_authenticated/vehicles_.$vehicleId/identity'
import { Route as AuthenticatedVehiclesVehicleIdInsuranceRouteImport } from './routes/_authenticated/vehicles_.$vehicleId/insurance'
import { Route as AuthenticatedVehiclesVehicleIdOptionsRouteImport } from './routes/_authenticated/vehicles_.$vehicleId/options'
import { Route as AuthenticatedVehiclesVehicleIdSpecificationsRouteImport } from './routes/_authenticated/vehicles_.$vehicleId/specifications'
import { Route as AuthenticatedVehiclesVehicleIdOverviewRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview'
import { Route as AuthenticatedWorkOrdersWorkOrderIdIndexRouteImport } from './routes/_authenticated/work-orders_.$workOrderId/index'
import { Route as AuthenticatedWorkOrdersWorkOrderIdDamageChartRouteImport } from './routes/_authenticated/work-orders_.$workOrderId/damage-chart'
import { Route as AuthenticatedWorkOrdersWorkOrderIdDocumentsRouteImport } from './routes/_authenticated/work-orders_.$workOrderId/documents'
import { Route as AuthenticatedWorkOrdersWorkOrderIdItemsRouteImport } from './routes/_authenticated/work-orders_.$workOrderId/items'
import { Route as AuthenticatedWorkOrdersWorkOrderIdTimelineRouteImport } from './routes/_authenticated/work-orders_.$workOrderId/timeline'
import { Route as AuthenticatedLeasingContractsContractIdEditRouteImport } from './routes/_authenticated/leasing/contracts_.$contractId_.edit'
import { Route as AuthenticatedSettingsLocationsLocationIdIndexRouteImport } from './routes/_authenticated/settings_.locations.$locationId/index'
import { Route as AuthenticatedSettingsLocationsLocationIdDivisionsRouteImport } from './routes/_authenticated/settings_.locations.$locationId/divisions'
import { Route as AuthenticatedSettingsLocationsLocationIdTimeslotsRouteImport } from './routes/_authenticated/settings_.locations.$locationId/timeslots'
import { Route as AuthenticatedSettingsLocationsLocationIdUsersRouteImport } from './routes/_authenticated/settings_.locations.$locationId/users'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdIndexRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/index'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdCustomersRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/customers'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdDriversRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/drivers'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/energy-source-prices'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdLeasingRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/leasing'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdLocationsRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/locations'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/suppliers'
import { Route as AuthenticatedSettingsTerritoriesTerritoryIdUsersRouteImport } from './routes/_authenticated/settings_.territories.$territoryId/users'
import { Route as AuthenticatedVehiclesVehicleIdOverviewIndexRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/index'
import { Route as AuthenticatedVehiclesVehicleIdOverviewAcquisitionRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/acquisition'
import { Route as AuthenticatedVehiclesVehicleIdOverviewExpensesRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/expenses'
import { Route as AuthenticatedVehiclesVehicleIdOverviewFuelLevelRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/fuel-level'
import { Route as AuthenticatedVehiclesVehicleIdOverviewInsuranceRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/insurance'
import { Route as AuthenticatedVehiclesVehicleIdOverviewMaintenanceRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/maintenance'
import { Route as AuthenticatedVehiclesVehicleIdOverviewOdometerRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/odometer'
import { Route as AuthenticatedVehiclesVehicleIdOverviewUsageRouteImport } from './routes/_authenticated/vehicles_.$vehicleId_.overview/usage'
import { Route as AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRouteImport } from './routes/_authenticated/leasing/contracts_.$contractId_.agreements.$agreementId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentTestRoute =
  AuthenticatedDocumentTestRouteImport.update({
    id: '/document-test',
    path: '/document-test',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInspectionsRoute =
  AuthenticatedInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIssuesRoute = AuthenticatedIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLeasingRoute = AuthenticatedLeasingRouteImport.update({
  id: '/leasing',
  path: '/leasing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRemindersRoute = AuthenticatedRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVehiclesRoute = AuthenticatedVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorkOrdersRoute = AuthenticatedWorkOrdersRouteImport.update({
  id: '/work-orders',
  path: '/work-orders',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLeasingIndexRoute =
  AuthenticatedLeasingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedLeasingAnalyticsRoute =
  AuthenticatedLeasingAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedLeasingBillingRoute =
  AuthenticatedLeasingBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedLeasingContractsRoute =
  AuthenticatedLeasingContractsRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedLeasingLeasedVehiclesRoute =
  AuthenticatedLeasingLeasedVehiclesRouteImport.update({
    id: '/leased-vehicles',
    path: '/leased-vehicles',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedLeasingOrderPipelineRoute =
  AuthenticatedLeasingOrderPipelineRouteImport.update({
    id: '/order-pipeline',
    path: '/order-pipeline',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsFleetRoute =
  AuthenticatedSettingsFleetRouteImport.update({
    id: '/settings_/fleet',
    path: '/settings/fleet',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsInspectionsRoute =
  AuthenticatedSettingsInspectionsRouteImport.update({
    id: '/settings_/inspections',
    path: '/settings/inspections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsMaintenanceRoute =
  AuthenticatedSettingsMaintenanceRouteImport.update({
    id: '/settings_/maintenance',
    path: '/settings/maintenance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsTenantProfileRoute =
  AuthenticatedSettingsTenantProfileRouteImport.update({
    id: '/settings_/tenant-profile',
    path: '/settings/tenant-profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsTerritoriesRoute =
  AuthenticatedSettingsTerritoriesRouteImport.update({
    id: '/settings_/territories',
    path: '/settings/territories',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/settings_/users',
    path: '/settings/users',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdRoute =
  AuthenticatedVehiclesVehicleIdRouteImport.update({
    id: '/vehicles_/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVehiclesAddRoute =
  AuthenticatedVehiclesAddRouteImport.update({
    id: '/vehicles_/add',
    path: '/vehicles/add',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdRoute =
  AuthenticatedWorkOrdersWorkOrderIdRouteImport.update({
    id: '/work-orders_/$workOrderId',
    path: '/work-orders/$workOrderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeasingContractsContractIdRoute =
  AuthenticatedLeasingContractsContractIdRouteImport.update({
    id: '/contracts_/$contractId',
    path: '/contracts/$contractId',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedLeasingContractsNewRoute =
  AuthenticatedLeasingContractsNewRouteImport.update({
    id: '/contracts_/new',
    path: '/contracts/new',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedSettingsFleetIndexRoute =
  AuthenticatedSettingsFleetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetEnergySourcesRoute =
  AuthenticatedSettingsFleetEnergySourcesRouteImport.update({
    id: '/energy-sources',
    path: '/energy-sources',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetExpenseCategoriesRoute =
  AuthenticatedSettingsFleetExpenseCategoriesRouteImport.update({
    id: '/expense-categories',
    path: '/expense-categories',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetVehicleGroupsRoute =
  AuthenticatedSettingsFleetVehicleGroupsRouteImport.update({
    id: '/vehicle-groups',
    path: '/vehicle-groups',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetVehicleMakesRoute =
  AuthenticatedSettingsFleetVehicleMakesRouteImport.update({
    id: '/vehicle-makes',
    path: '/vehicle-makes',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetVehicleModelsRoute =
  AuthenticatedSettingsFleetVehicleModelsRouteImport.update({
    id: '/vehicle-models',
    path: '/vehicle-models',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetVehicleOwnershipsRoute =
  AuthenticatedSettingsFleetVehicleOwnershipsRouteImport.update({
    id: '/vehicle-ownerships',
    path: '/vehicle-ownerships',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsFleetVehicleTypesRoute =
  AuthenticatedSettingsFleetVehicleTypesRouteImport.update({
    id: '/vehicle-types',
    path: '/vehicle-types',
    getParentRoute: () => AuthenticatedSettingsFleetRoute,
  } as any)
const AuthenticatedSettingsLocationsLocationIdRoute =
  AuthenticatedSettingsLocationsLocationIdRouteImport.update({
    id: '/settings_/locations/$locationId',
    path: '/settings/locations/$locationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsMaintenanceIndexRoute =
  AuthenticatedSettingsMaintenanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsMaintenanceRoute,
  } as any)
const AuthenticatedSettingsMaintenanceGeneralRoute =
  AuthenticatedSettingsMaintenanceGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsMaintenanceRoute,
  } as any)
const AuthenticatedSettingsMaintenanceServiceOperationsRoute =
  AuthenticatedSettingsMaintenanceServiceOperationsRouteImport.update({
    id: '/service-operations',
    path: '/service-operations',
    getParentRoute: () => AuthenticatedSettingsMaintenanceRoute,
  } as any)
const AuthenticatedSettingsMaintenanceServicePlansRoute =
  AuthenticatedSettingsMaintenanceServicePlansRouteImport.update({
    id: '/service-plans',
    path: '/service-plans',
    getParentRoute: () => AuthenticatedSettingsMaintenanceRoute,
  } as any)
const AuthenticatedSettingsTenantProfileIndexRoute =
  AuthenticatedSettingsTenantProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsTenantProfileRoute,
  } as any)
const AuthenticatedSettingsTenantProfileGeneralRoute =
  AuthenticatedSettingsTenantProfileGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsTenantProfileRoute,
  } as any)
const AuthenticatedSettingsTenantProfileModulesRoute =
  AuthenticatedSettingsTenantProfileModulesRouteImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => AuthenticatedSettingsTenantProfileRoute,
  } as any)
const AuthenticatedSettingsTenantProfileOwnerRoute =
  AuthenticatedSettingsTenantProfileOwnerRouteImport.update({
    id: '/owner',
    path: '/owner',
    getParentRoute: () => AuthenticatedSettingsTenantProfileRoute,
  } as any)
const AuthenticatedSettingsTenantProfilePoolTypesRoute =
  AuthenticatedSettingsTenantProfilePoolTypesRouteImport.update({
    id: '/pool-types',
    path: '/pool-types',
    getParentRoute: () => AuthenticatedSettingsTenantProfileRoute,
  } as any)
const AuthenticatedSettingsTerritoriesIndexRoute =
  AuthenticatedSettingsTerritoriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsTerritoriesRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdRouteImport.update({
    id: '/$territoryId',
    path: '/$territoryId',
    getParentRoute: () => AuthenticatedSettingsTerritoriesRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdIndexRoute =
  AuthenticatedVehiclesVehicleIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdAcquisitionRoute =
  AuthenticatedVehiclesVehicleIdAcquisitionRouteImport.update({
    id: '/acquisition',
    path: '/acquisition',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdIdentityRoute =
  AuthenticatedVehiclesVehicleIdIdentityRouteImport.update({
    id: '/identity',
    path: '/identity',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdInsuranceRoute =
  AuthenticatedVehiclesVehicleIdInsuranceRouteImport.update({
    id: '/insurance',
    path: '/insurance',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOptionsRoute =
  AuthenticatedVehiclesVehicleIdOptionsRouteImport.update({
    id: '/options',
    path: '/options',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdSpecificationsRoute =
  AuthenticatedVehiclesVehicleIdSpecificationsRouteImport.update({
    id: '/specifications',
    path: '/specifications',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewRoute =
  AuthenticatedVehiclesVehicleIdOverviewRouteImport.update({
    id: '/vehicles_/$vehicleId_/overview',
    path: '/vehicles/$vehicleId/overview',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdIndexRoute =
  AuthenticatedWorkOrdersWorkOrderIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkOrdersWorkOrderIdRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute =
  AuthenticatedWorkOrdersWorkOrderIdDamageChartRouteImport.update({
    id: '/damage-chart',
    path: '/damage-chart',
    getParentRoute: () => AuthenticatedWorkOrdersWorkOrderIdRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute =
  AuthenticatedWorkOrdersWorkOrderIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedWorkOrdersWorkOrderIdRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdItemsRoute =
  AuthenticatedWorkOrdersWorkOrderIdItemsRouteImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () => AuthenticatedWorkOrdersWorkOrderIdRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdTimelineRoute =
  AuthenticatedWorkOrdersWorkOrderIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthenticatedWorkOrdersWorkOrderIdRoute,
  } as any)
const AuthenticatedLeasingContractsContractIdEditRoute =
  AuthenticatedLeasingContractsContractIdEditRouteImport.update({
    id: '/contracts_/$contractId_/edit',
    path: '/contracts/$contractId/edit',
    getParentRoute: () => AuthenticatedLeasingRoute,
  } as any)
const AuthenticatedSettingsLocationsLocationIdIndexRoute =
  AuthenticatedSettingsLocationsLocationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedSettingsLocationsLocationIdDivisionsRoute =
  AuthenticatedSettingsLocationsLocationIdDivisionsRouteImport.update({
    id: '/divisions',
    path: '/divisions',
    getParentRoute: () => AuthenticatedSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedSettingsLocationsLocationIdTimeslotsRoute =
  AuthenticatedSettingsLocationsLocationIdTimeslotsRouteImport.update({
    id: '/timeslots',
    path: '/timeslots',
    getParentRoute: () => AuthenticatedSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedSettingsLocationsLocationIdUsersRoute =
  AuthenticatedSettingsLocationsLocationIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdDriversRouteImport.update({
    id: '/drivers',
    path: '/drivers',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRouteImport.update(
    {
      id: '/energy-source-prices',
      path: '/energy-source-prices',
      getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
    } as any,
  )
const AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdLeasingRouteImport.update({
    id: '/leasing',
    path: '/leasing',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute =
  AuthenticatedSettingsTerritoriesTerritoryIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsTerritoriesTerritoryIdRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewIndexRoute =
  AuthenticatedVehiclesVehicleIdOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute =
  AuthenticatedVehiclesVehicleIdOverviewAcquisitionRouteImport.update({
    id: '/acquisition',
    path: '/acquisition',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewExpensesRoute =
  AuthenticatedVehiclesVehicleIdOverviewExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute =
  AuthenticatedVehiclesVehicleIdOverviewFuelLevelRouteImport.update({
    id: '/fuel-level',
    path: '/fuel-level',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute =
  AuthenticatedVehiclesVehicleIdOverviewInsuranceRouteImport.update({
    id: '/insurance',
    path: '/insurance',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute =
  AuthenticatedVehiclesVehicleIdOverviewMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewOdometerRoute =
  AuthenticatedVehiclesVehicleIdOverviewOdometerRouteImport.update({
    id: '/odometer',
    path: '/odometer',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdOverviewUsageRoute =
  AuthenticatedVehiclesVehicleIdOverviewUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedVehiclesVehicleIdOverviewRoute,
  } as any)
const AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute =
  AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRouteImport.update(
    {
      id: '/contracts_/$contractId_/agreements/$agreementId',
      path: '/contracts/$contractId/agreements/$agreementId',
      getParentRoute: () => AuthenticatedLeasingRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/activate': typeof ActivateRoute
  '/document-test': typeof AuthenticatedDocumentTestRoute
  '/inspections': typeof AuthenticatedInspectionsRoute
  '/issues': typeof AuthenticatedIssuesRoute
  '/leasing': typeof AuthenticatedLeasingRouteWithChildren
  '/reminders': typeof AuthenticatedRemindersRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/vehicles': typeof AuthenticatedVehiclesRoute
  '/work-orders': typeof AuthenticatedWorkOrdersRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/r/$token': typeof RTokenRoute
  '/leasing/analytics': typeof AuthenticatedLeasingAnalyticsRoute
  '/leasing/billing': typeof AuthenticatedLeasingBillingRoute
  '/leasing/contracts': typeof AuthenticatedLeasingContractsRoute
  '/leasing/leased-vehicles': typeof AuthenticatedLeasingLeasedVehiclesRoute
  '/leasing/order-pipeline': typeof AuthenticatedLeasingOrderPipelineRoute
  '/settings/fleet': typeof AuthenticatedSettingsFleetRouteWithChildren
  '/settings/inspections': typeof AuthenticatedSettingsInspectionsRoute
  '/settings/maintenance': typeof AuthenticatedSettingsMaintenanceRouteWithChildren
  '/settings/tenant-profile': typeof AuthenticatedSettingsTenantProfileRouteWithChildren
  '/settings/territories': typeof AuthenticatedSettingsTerritoriesRouteWithChildren
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/vehicles/$vehicleId': typeof AuthenticatedVehiclesVehicleIdRouteWithChildren
  '/vehicles/add': typeof AuthenticatedVehiclesAddRoute
  '/work-orders/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdRouteWithChildren
  '/leasing/': typeof AuthenticatedLeasingIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/leasing/contracts/$contractId': typeof AuthenticatedLeasingContractsContractIdRoute
  '/leasing/contracts/new': typeof AuthenticatedLeasingContractsNewRoute
  '/settings/fleet/energy-sources': typeof AuthenticatedSettingsFleetEnergySourcesRoute
  '/settings/fleet/expense-categories': typeof AuthenticatedSettingsFleetExpenseCategoriesRoute
  '/settings/fleet/vehicle-groups': typeof AuthenticatedSettingsFleetVehicleGroupsRoute
  '/settings/fleet/vehicle-makes': typeof AuthenticatedSettingsFleetVehicleMakesRoute
  '/settings/fleet/vehicle-models': typeof AuthenticatedSettingsFleetVehicleModelsRoute
  '/settings/fleet/vehicle-ownerships': typeof AuthenticatedSettingsFleetVehicleOwnershipsRoute
  '/settings/fleet/vehicle-types': typeof AuthenticatedSettingsFleetVehicleTypesRoute
  '/settings/locations/$locationId': typeof AuthenticatedSettingsLocationsLocationIdRouteWithChildren
  '/settings/maintenance/general': typeof AuthenticatedSettingsMaintenanceGeneralRoute
  '/settings/maintenance/service-operations': typeof AuthenticatedSettingsMaintenanceServiceOperationsRoute
  '/settings/maintenance/service-plans': typeof AuthenticatedSettingsMaintenanceServicePlansRoute
  '/settings/tenant-profile/general': typeof AuthenticatedSettingsTenantProfileGeneralRoute
  '/settings/tenant-profile/modules': typeof AuthenticatedSettingsTenantProfileModulesRoute
  '/settings/tenant-profile/owner': typeof AuthenticatedSettingsTenantProfileOwnerRoute
  '/settings/tenant-profile/pool-types': typeof AuthenticatedSettingsTenantProfilePoolTypesRoute
  '/settings/territories/$territoryId': typeof AuthenticatedSettingsTerritoriesTerritoryIdRouteWithChildren
  '/vehicles/$vehicleId/acquisition': typeof AuthenticatedVehiclesVehicleIdAcquisitionRoute
  '/vehicles/$vehicleId/identity': typeof AuthenticatedVehiclesVehicleIdIdentityRoute
  '/vehicles/$vehicleId/insurance': typeof AuthenticatedVehiclesVehicleIdInsuranceRoute
  '/vehicles/$vehicleId/options': typeof AuthenticatedVehiclesVehicleIdOptionsRoute
  '/vehicles/$vehicleId/specifications': typeof AuthenticatedVehiclesVehicleIdSpecificationsRoute
  '/vehicles/$vehicleId/overview': typeof AuthenticatedVehiclesVehicleIdOverviewRouteWithChildren
  '/work-orders/$workOrderId/damage-chart': typeof AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute
  '/work-orders/$workOrderId/documents': typeof AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute
  '/work-orders/$workOrderId/items': typeof AuthenticatedWorkOrdersWorkOrderIdItemsRoute
  '/work-orders/$workOrderId/timeline': typeof AuthenticatedWorkOrdersWorkOrderIdTimelineRoute
  '/settings/fleet/': typeof AuthenticatedSettingsFleetIndexRoute
  '/settings/maintenance/': typeof AuthenticatedSettingsMaintenanceIndexRoute
  '/settings/tenant-profile/': typeof AuthenticatedSettingsTenantProfileIndexRoute
  '/settings/territories/': typeof AuthenticatedSettingsTerritoriesIndexRoute
  '/vehicles/$vehicleId/': typeof AuthenticatedVehiclesVehicleIdIndexRoute
  '/work-orders/$workOrderId/': typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  '/leasing/contracts/$contractId/edit': typeof AuthenticatedLeasingContractsContractIdEditRoute
  '/settings/locations/$locationId/divisions': typeof AuthenticatedSettingsLocationsLocationIdDivisionsRoute
  '/settings/locations/$locationId/timeslots': typeof AuthenticatedSettingsLocationsLocationIdTimeslotsRoute
  '/settings/locations/$locationId/users': typeof AuthenticatedSettingsLocationsLocationIdUsersRoute
  '/settings/territories/$territoryId/customers': typeof AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute
  '/settings/territories/$territoryId/drivers': typeof AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute
  '/settings/territories/$territoryId/energy-source-prices': typeof AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute
  '/settings/territories/$territoryId/leasing': typeof AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute
  '/settings/territories/$territoryId/locations': typeof AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute
  '/settings/territories/$territoryId/suppliers': typeof AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute
  '/settings/territories/$territoryId/users': typeof AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute
  '/vehicles/$vehicleId/overview/acquisition': typeof AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute
  '/vehicles/$vehicleId/overview/expenses': typeof AuthenticatedVehiclesVehicleIdOverviewExpensesRoute
  '/vehicles/$vehicleId/overview/fuel-level': typeof AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute
  '/vehicles/$vehicleId/overview/insurance': typeof AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute
  '/vehicles/$vehicleId/overview/maintenance': typeof AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute
  '/vehicles/$vehicleId/overview/odometer': typeof AuthenticatedVehiclesVehicleIdOverviewOdometerRoute
  '/vehicles/$vehicleId/overview/usage': typeof AuthenticatedVehiclesVehicleIdOverviewUsageRoute
  '/settings/locations/$locationId/': typeof AuthenticatedSettingsLocationsLocationIdIndexRoute
  '/settings/territories/$territoryId/': typeof AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute
  '/vehicles/$vehicleId/overview/': typeof AuthenticatedVehiclesVehicleIdOverviewIndexRoute
  '/leasing/contracts/$contractId/agreements/$agreementId': typeof AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/activate': typeof ActivateRoute
  '/document-test': typeof AuthenticatedDocumentTestRoute
  '/inspections': typeof AuthenticatedInspectionsRoute
  '/issues': typeof AuthenticatedIssuesRoute
  '/reminders': typeof AuthenticatedRemindersRoute
  '/vehicles': typeof AuthenticatedVehiclesRoute
  '/work-orders': typeof AuthenticatedWorkOrdersRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/r/$token': typeof RTokenRoute
  '/leasing/analytics': typeof AuthenticatedLeasingAnalyticsRoute
  '/leasing/billing': typeof AuthenticatedLeasingBillingRoute
  '/leasing/contracts': typeof AuthenticatedLeasingContractsRoute
  '/leasing/leased-vehicles': typeof AuthenticatedLeasingLeasedVehiclesRoute
  '/leasing/order-pipeline': typeof AuthenticatedLeasingOrderPipelineRoute
  '/settings/inspections': typeof AuthenticatedSettingsInspectionsRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/vehicles/add': typeof AuthenticatedVehiclesAddRoute
  '/leasing': typeof AuthenticatedLeasingIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/leasing/contracts/$contractId': typeof AuthenticatedLeasingContractsContractIdRoute
  '/leasing/contracts/new': typeof AuthenticatedLeasingContractsNewRoute
  '/settings/fleet/energy-sources': typeof AuthenticatedSettingsFleetEnergySourcesRoute
  '/settings/fleet/expense-categories': typeof AuthenticatedSettingsFleetExpenseCategoriesRoute
  '/settings/fleet/vehicle-groups': typeof AuthenticatedSettingsFleetVehicleGroupsRoute
  '/settings/fleet/vehicle-makes': typeof AuthenticatedSettingsFleetVehicleMakesRoute
  '/settings/fleet/vehicle-models': typeof AuthenticatedSettingsFleetVehicleModelsRoute
  '/settings/fleet/vehicle-ownerships': typeof AuthenticatedSettingsFleetVehicleOwnershipsRoute
  '/settings/fleet/vehicle-types': typeof AuthenticatedSettingsFleetVehicleTypesRoute
  '/settings/maintenance/general': typeof AuthenticatedSettingsMaintenanceGeneralRoute
  '/settings/maintenance/service-operations': typeof AuthenticatedSettingsMaintenanceServiceOperationsRoute
  '/settings/maintenance/service-plans': typeof AuthenticatedSettingsMaintenanceServicePlansRoute
  '/settings/tenant-profile/general': typeof AuthenticatedSettingsTenantProfileGeneralRoute
  '/settings/tenant-profile/modules': typeof AuthenticatedSettingsTenantProfileModulesRoute
  '/settings/tenant-profile/owner': typeof AuthenticatedSettingsTenantProfileOwnerRoute
  '/settings/tenant-profile/pool-types': typeof AuthenticatedSettingsTenantProfilePoolTypesRoute
  '/vehicles/$vehicleId/acquisition': typeof AuthenticatedVehiclesVehicleIdAcquisitionRoute
  '/vehicles/$vehicleId/identity': typeof AuthenticatedVehiclesVehicleIdIdentityRoute
  '/vehicles/$vehicleId/insurance': typeof AuthenticatedVehiclesVehicleIdInsuranceRoute
  '/vehicles/$vehicleId/options': typeof AuthenticatedVehiclesVehicleIdOptionsRoute
  '/vehicles/$vehicleId/specifications': typeof AuthenticatedVehiclesVehicleIdSpecificationsRoute
  '/work-orders/$workOrderId/damage-chart': typeof AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute
  '/work-orders/$workOrderId/documents': typeof AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute
  '/work-orders/$workOrderId/items': typeof AuthenticatedWorkOrdersWorkOrderIdItemsRoute
  '/work-orders/$workOrderId/timeline': typeof AuthenticatedWorkOrdersWorkOrderIdTimelineRoute
  '/settings/fleet': typeof AuthenticatedSettingsFleetIndexRoute
  '/settings/maintenance': typeof AuthenticatedSettingsMaintenanceIndexRoute
  '/settings/tenant-profile': typeof AuthenticatedSettingsTenantProfileIndexRoute
  '/settings/territories': typeof AuthenticatedSettingsTerritoriesIndexRoute
  '/vehicles/$vehicleId': typeof AuthenticatedVehiclesVehicleIdIndexRoute
  '/work-orders/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  '/leasing/contracts/$contractId/edit': typeof AuthenticatedLeasingContractsContractIdEditRoute
  '/settings/locations/$locationId/divisions': typeof AuthenticatedSettingsLocationsLocationIdDivisionsRoute
  '/settings/locations/$locationId/timeslots': typeof AuthenticatedSettingsLocationsLocationIdTimeslotsRoute
  '/settings/locations/$locationId/users': typeof AuthenticatedSettingsLocationsLocationIdUsersRoute
  '/settings/territories/$territoryId/customers': typeof AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute
  '/settings/territories/$territoryId/drivers': typeof AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute
  '/settings/territories/$territoryId/energy-source-prices': typeof AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute
  '/settings/territories/$territoryId/leasing': typeof AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute
  '/settings/territories/$territoryId/locations': typeof AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute
  '/settings/territories/$territoryId/suppliers': typeof AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute
  '/settings/territories/$territoryId/users': typeof AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute
  '/vehicles/$vehicleId/overview/acquisition': typeof AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute
  '/vehicles/$vehicleId/overview/expenses': typeof AuthenticatedVehiclesVehicleIdOverviewExpensesRoute
  '/vehicles/$vehicleId/overview/fuel-level': typeof AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute
  '/vehicles/$vehicleId/overview/insurance': typeof AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute
  '/vehicles/$vehicleId/overview/maintenance': typeof AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute
  '/vehicles/$vehicleId/overview/odometer': typeof AuthenticatedVehiclesVehicleIdOverviewOdometerRoute
  '/vehicles/$vehicleId/overview/usage': typeof AuthenticatedVehiclesVehicleIdOverviewUsageRoute
  '/settings/locations/$locationId': typeof AuthenticatedSettingsLocationsLocationIdIndexRoute
  '/settings/territories/$territoryId': typeof AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute
  '/vehicles/$vehicleId/overview': typeof AuthenticatedVehiclesVehicleIdOverviewIndexRoute
  '/leasing/contracts/$contractId/agreements/$agreementId': typeof AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/activate': typeof ActivateRoute
  '/_authenticated/document-test': typeof AuthenticatedDocumentTestRoute
  '/_authenticated/inspections': typeof AuthenticatedInspectionsRoute
  '/_authenticated/issues': typeof AuthenticatedIssuesRoute
  '/_authenticated/leasing': typeof AuthenticatedLeasingRouteWithChildren
  '/_authenticated/reminders': typeof AuthenticatedRemindersRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/vehicles': typeof AuthenticatedVehiclesRoute
  '/_authenticated/work-orders': typeof AuthenticatedWorkOrdersRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/r/$token': typeof RTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/leasing/analytics': typeof AuthenticatedLeasingAnalyticsRoute
  '/_authenticated/leasing/billing': typeof AuthenticatedLeasingBillingRoute
  '/_authenticated/leasing/contracts': typeof AuthenticatedLeasingContractsRoute
  '/_authenticated/leasing/leased-vehicles': typeof AuthenticatedLeasingLeasedVehiclesRoute
  '/_authenticated/leasing/order-pipeline': typeof AuthenticatedLeasingOrderPipelineRoute
  '/_authenticated/settings_/fleet': typeof AuthenticatedSettingsFleetRouteWithChildren
  '/_authenticated/settings_/inspections': typeof AuthenticatedSettingsInspectionsRoute
  '/_authenticated/settings_/maintenance': typeof AuthenticatedSettingsMaintenanceRouteWithChildren
  '/_authenticated/settings_/tenant-profile': typeof AuthenticatedSettingsTenantProfileRouteWithChildren
  '/_authenticated/settings_/territories': typeof AuthenticatedSettingsTerritoriesRouteWithChildren
  '/_authenticated/settings_/users': typeof AuthenticatedSettingsUsersRoute
  '/_authenticated/vehicles_/$vehicleId': typeof AuthenticatedVehiclesVehicleIdRouteWithChildren
  '/_authenticated/vehicles_/add': typeof AuthenticatedVehiclesAddRoute
  '/_authenticated/work-orders_/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdRouteWithChildren
  '/_authenticated/leasing/': typeof AuthenticatedLeasingIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/leasing/contracts_/$contractId': typeof AuthenticatedLeasingContractsContractIdRoute
  '/_authenticated/leasing/contracts_/new': typeof AuthenticatedLeasingContractsNewRoute
  '/_authenticated/settings_/fleet/energy-sources': typeof AuthenticatedSettingsFleetEnergySourcesRoute
  '/_authenticated/settings_/fleet/expense-categories': typeof AuthenticatedSettingsFleetExpenseCategoriesRoute
  '/_authenticated/settings_/fleet/vehicle-groups': typeof AuthenticatedSettingsFleetVehicleGroupsRoute
  '/_authenticated/settings_/fleet/vehicle-makes': typeof AuthenticatedSettingsFleetVehicleMakesRoute
  '/_authenticated/settings_/fleet/vehicle-models': typeof AuthenticatedSettingsFleetVehicleModelsRoute
  '/_authenticated/settings_/fleet/vehicle-ownerships': typeof AuthenticatedSettingsFleetVehicleOwnershipsRoute
  '/_authenticated/settings_/fleet/vehicle-types': typeof AuthenticatedSettingsFleetVehicleTypesRoute
  '/_authenticated/settings_/locations/$locationId': typeof AuthenticatedSettingsLocationsLocationIdRouteWithChildren
  '/_authenticated/settings_/maintenance/general': typeof AuthenticatedSettingsMaintenanceGeneralRoute
  '/_authenticated/settings_/maintenance/service-operations': typeof AuthenticatedSettingsMaintenanceServiceOperationsRoute
  '/_authenticated/settings_/maintenance/service-plans': typeof AuthenticatedSettingsMaintenanceServicePlansRoute
  '/_authenticated/settings_/tenant-profile/general': typeof AuthenticatedSettingsTenantProfileGeneralRoute
  '/_authenticated/settings_/tenant-profile/modules': typeof AuthenticatedSettingsTenantProfileModulesRoute
  '/_authenticated/settings_/tenant-profile/owner': typeof AuthenticatedSettingsTenantProfileOwnerRoute
  '/_authenticated/settings_/tenant-profile/pool-types': typeof AuthenticatedSettingsTenantProfilePoolTypesRoute
  '/_authenticated/settings_/territories/$territoryId': typeof AuthenticatedSettingsTerritoriesTerritoryIdRouteWithChildren
  '/_authenticated/vehicles_/$vehicleId/acquisition': typeof AuthenticatedVehiclesVehicleIdAcquisitionRoute
  '/_authenticated/vehicles_/$vehicleId/identity': typeof AuthenticatedVehiclesVehicleIdIdentityRoute
  '/_authenticated/vehicles_/$vehicleId/insurance': typeof AuthenticatedVehiclesVehicleIdInsuranceRoute
  '/_authenticated/vehicles_/$vehicleId/options': typeof AuthenticatedVehiclesVehicleIdOptionsRoute
  '/_authenticated/vehicles_/$vehicleId/specifications': typeof AuthenticatedVehiclesVehicleIdSpecificationsRoute
  '/_authenticated/vehicles_/$vehicleId_/overview': typeof AuthenticatedVehiclesVehicleIdOverviewRouteWithChildren
  '/_authenticated/work-orders_/$workOrderId/damage-chart': typeof AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute
  '/_authenticated/work-orders_/$workOrderId/documents': typeof AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute
  '/_authenticated/work-orders_/$workOrderId/items': typeof AuthenticatedWorkOrdersWorkOrderIdItemsRoute
  '/_authenticated/work-orders_/$workOrderId/timeline': typeof AuthenticatedWorkOrdersWorkOrderIdTimelineRoute
  '/_authenticated/settings_/fleet/': typeof AuthenticatedSettingsFleetIndexRoute
  '/_authenticated/settings_/maintenance/': typeof AuthenticatedSettingsMaintenanceIndexRoute
  '/_authenticated/settings_/tenant-profile/': typeof AuthenticatedSettingsTenantProfileIndexRoute
  '/_authenticated/settings_/territories/': typeof AuthenticatedSettingsTerritoriesIndexRoute
  '/_authenticated/vehicles_/$vehicleId/': typeof AuthenticatedVehiclesVehicleIdIndexRoute
  '/_authenticated/work-orders_/$workOrderId/': typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  '/_authenticated/leasing/contracts_/$contractId_/edit': typeof AuthenticatedLeasingContractsContractIdEditRoute
  '/_authenticated/settings_/locations/$locationId/divisions': typeof AuthenticatedSettingsLocationsLocationIdDivisionsRoute
  '/_authenticated/settings_/locations/$locationId/timeslots': typeof AuthenticatedSettingsLocationsLocationIdTimeslotsRoute
  '/_authenticated/settings_/locations/$locationId/users': typeof AuthenticatedSettingsLocationsLocationIdUsersRoute
  '/_authenticated/settings_/territories/$territoryId/customers': typeof AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute
  '/_authenticated/settings_/territories/$territoryId/drivers': typeof AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute
  '/_authenticated/settings_/territories/$territoryId/energy-source-prices': typeof AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute
  '/_authenticated/settings_/territories/$territoryId/leasing': typeof AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute
  '/_authenticated/settings_/territories/$territoryId/locations': typeof AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute
  '/_authenticated/settings_/territories/$territoryId/suppliers': typeof AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute
  '/_authenticated/settings_/territories/$territoryId/users': typeof AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/acquisition': typeof AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/expenses': typeof AuthenticatedVehiclesVehicleIdOverviewExpensesRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/fuel-level': typeof AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/insurance': typeof AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/maintenance': typeof AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/odometer': typeof AuthenticatedVehiclesVehicleIdOverviewOdometerRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/usage': typeof AuthenticatedVehiclesVehicleIdOverviewUsageRoute
  '/_authenticated/settings_/locations/$locationId/': typeof AuthenticatedSettingsLocationsLocationIdIndexRoute
  '/_authenticated/settings_/territories/$territoryId/': typeof AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute
  '/_authenticated/vehicles_/$vehicleId_/overview/': typeof AuthenticatedVehiclesVehicleIdOverviewIndexRoute
  '/_authenticated/leasing/contracts_/$contractId_/agreements/$agreementId': typeof AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/document-test'
    | '/inspections'
    | '/issues'
    | '/leasing'
    | '/reminders'
    | '/settings'
    | '/vehicles'
    | '/work-orders'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/r/$token'
    | '/leasing/analytics'
    | '/leasing/billing'
    | '/leasing/contracts'
    | '/leasing/leased-vehicles'
    | '/leasing/order-pipeline'
    | '/settings/fleet'
    | '/settings/inspections'
    | '/settings/maintenance'
    | '/settings/tenant-profile'
    | '/settings/territories'
    | '/settings/users'
    | '/vehicles/$vehicleId'
    | '/vehicles/add'
    | '/work-orders/$workOrderId'
    | '/leasing/'
    | '/settings/'
    | '/leasing/contracts/$contractId'
    | '/leasing/contracts/new'
    | '/settings/fleet/energy-sources'
    | '/settings/fleet/expense-categories'
    | '/settings/fleet/vehicle-groups'
    | '/settings/fleet/vehicle-makes'
    | '/settings/fleet/vehicle-models'
    | '/settings/fleet/vehicle-ownerships'
    | '/settings/fleet/vehicle-types'
    | '/settings/locations/$locationId'
    | '/settings/maintenance/general'
    | '/settings/maintenance/service-operations'
    | '/settings/maintenance/service-plans'
    | '/settings/tenant-profile/general'
    | '/settings/tenant-profile/modules'
    | '/settings/tenant-profile/owner'
    | '/settings/tenant-profile/pool-types'
    | '/settings/territories/$territoryId'
    | '/vehicles/$vehicleId/acquisition'
    | '/vehicles/$vehicleId/identity'
    | '/vehicles/$vehicleId/insurance'
    | '/vehicles/$vehicleId/options'
    | '/vehicles/$vehicleId/specifications'
    | '/vehicles/$vehicleId/overview'
    | '/work-orders/$workOrderId/damage-chart'
    | '/work-orders/$workOrderId/documents'
    | '/work-orders/$workOrderId/items'
    | '/work-orders/$workOrderId/timeline'
    | '/settings/fleet/'
    | '/settings/maintenance/'
    | '/settings/tenant-profile/'
    | '/settings/territories/'
    | '/vehicles/$vehicleId/'
    | '/work-orders/$workOrderId/'
    | '/leasing/contracts/$contractId/edit'
    | '/settings/locations/$locationId/divisions'
    | '/settings/locations/$locationId/timeslots'
    | '/settings/locations/$locationId/users'
    | '/settings/territories/$territoryId/customers'
    | '/settings/territories/$territoryId/drivers'
    | '/settings/territories/$territoryId/energy-source-prices'
    | '/settings/territories/$territoryId/leasing'
    | '/settings/territories/$territoryId/locations'
    | '/settings/territories/$territoryId/suppliers'
    | '/settings/territories/$territoryId/users'
    | '/vehicles/$vehicleId/overview/acquisition'
    | '/vehicles/$vehicleId/overview/expenses'
    | '/vehicles/$vehicleId/overview/fuel-level'
    | '/vehicles/$vehicleId/overview/insurance'
    | '/vehicles/$vehicleId/overview/maintenance'
    | '/vehicles/$vehicleId/overview/odometer'
    | '/vehicles/$vehicleId/overview/usage'
    | '/settings/locations/$locationId/'
    | '/settings/territories/$territoryId/'
    | '/vehicles/$vehicleId/overview/'
    | '/leasing/contracts/$contractId/agreements/$agreementId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/document-test'
    | '/inspections'
    | '/issues'
    | '/reminders'
    | '/vehicles'
    | '/work-orders'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/r/$token'
    | '/leasing/analytics'
    | '/leasing/billing'
    | '/leasing/contracts'
    | '/leasing/leased-vehicles'
    | '/leasing/order-pipeline'
    | '/settings/inspections'
    | '/settings/users'
    | '/vehicles/add'
    | '/leasing'
    | '/settings'
    | '/leasing/contracts/$contractId'
    | '/leasing/contracts/new'
    | '/settings/fleet/energy-sources'
    | '/settings/fleet/expense-categories'
    | '/settings/fleet/vehicle-groups'
    | '/settings/fleet/vehicle-makes'
    | '/settings/fleet/vehicle-models'
    | '/settings/fleet/vehicle-ownerships'
    | '/settings/fleet/vehicle-types'
    | '/settings/maintenance/general'
    | '/settings/maintenance/service-operations'
    | '/settings/maintenance/service-plans'
    | '/settings/tenant-profile/general'
    | '/settings/tenant-profile/modules'
    | '/settings/tenant-profile/owner'
    | '/settings/tenant-profile/pool-types'
    | '/vehicles/$vehicleId/acquisition'
    | '/vehicles/$vehicleId/identity'
    | '/vehicles/$vehicleId/insurance'
    | '/vehicles/$vehicleId/options'
    | '/vehicles/$vehicleId/specifications'
    | '/work-orders/$workOrderId/damage-chart'
    | '/work-orders/$workOrderId/documents'
    | '/work-orders/$workOrderId/items'
    | '/work-orders/$workOrderId/timeline'
    | '/settings/fleet'
    | '/settings/maintenance'
    | '/settings/tenant-profile'
    | '/settings/territories'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/leasing/contracts/$contractId/edit'
    | '/settings/locations/$locationId/divisions'
    | '/settings/locations/$locationId/timeslots'
    | '/settings/locations/$locationId/users'
    | '/settings/territories/$territoryId/customers'
    | '/settings/territories/$territoryId/drivers'
    | '/settings/territories/$territoryId/energy-source-prices'
    | '/settings/territories/$territoryId/leasing'
    | '/settings/territories/$territoryId/locations'
    | '/settings/territories/$territoryId/suppliers'
    | '/settings/territories/$territoryId/users'
    | '/vehicles/$vehicleId/overview/acquisition'
    | '/vehicles/$vehicleId/overview/expenses'
    | '/vehicles/$vehicleId/overview/fuel-level'
    | '/vehicles/$vehicleId/overview/insurance'
    | '/vehicles/$vehicleId/overview/maintenance'
    | '/vehicles/$vehicleId/overview/odometer'
    | '/vehicles/$vehicleId/overview/usage'
    | '/settings/locations/$locationId'
    | '/settings/territories/$territoryId'
    | '/vehicles/$vehicleId/overview'
    | '/leasing/contracts/$contractId/agreements/$agreementId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/activate'
    | '/_authenticated/document-test'
    | '/_authenticated/inspections'
    | '/_authenticated/issues'
    | '/_authenticated/leasing'
    | '/_authenticated/reminders'
    | '/_authenticated/settings'
    | '/_authenticated/vehicles'
    | '/_authenticated/work-orders'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/r/$token'
    | '/_authenticated/'
    | '/_authenticated/leasing/analytics'
    | '/_authenticated/leasing/billing'
    | '/_authenticated/leasing/contracts'
    | '/_authenticated/leasing/leased-vehicles'
    | '/_authenticated/leasing/order-pipeline'
    | '/_authenticated/settings_/fleet'
    | '/_authenticated/settings_/inspections'
    | '/_authenticated/settings_/maintenance'
    | '/_authenticated/settings_/tenant-profile'
    | '/_authenticated/settings_/territories'
    | '/_authenticated/settings_/users'
    | '/_authenticated/vehicles_/$vehicleId'
    | '/_authenticated/vehicles_/add'
    | '/_authenticated/work-orders_/$workOrderId'
    | '/_authenticated/leasing/'
    | '/_authenticated/settings/'
    | '/_authenticated/leasing/contracts_/$contractId'
    | '/_authenticated/leasing/contracts_/new'
    | '/_authenticated/settings_/fleet/energy-sources'
    | '/_authenticated/settings_/fleet/expense-categories'
    | '/_authenticated/settings_/fleet/vehicle-groups'
    | '/_authenticated/settings_/fleet/vehicle-makes'
    | '/_authenticated/settings_/fleet/vehicle-models'
    | '/_authenticated/settings_/fleet/vehicle-ownerships'
    | '/_authenticated/settings_/fleet/vehicle-types'
    | '/_authenticated/settings_/locations/$locationId'
    | '/_authenticated/settings_/maintenance/general'
    | '/_authenticated/settings_/maintenance/service-operations'
    | '/_authenticated/settings_/maintenance/service-plans'
    | '/_authenticated/settings_/tenant-profile/general'
    | '/_authenticated/settings_/tenant-profile/modules'
    | '/_authenticated/settings_/tenant-profile/owner'
    | '/_authenticated/settings_/tenant-profile/pool-types'
    | '/_authenticated/settings_/territories/$territoryId'
    | '/_authenticated/vehicles_/$vehicleId/acquisition'
    | '/_authenticated/vehicles_/$vehicleId/identity'
    | '/_authenticated/vehicles_/$vehicleId/insurance'
    | '/_authenticated/vehicles_/$vehicleId/options'
    | '/_authenticated/vehicles_/$vehicleId/specifications'
    | '/_authenticated/vehicles_/$vehicleId_/overview'
    | '/_authenticated/work-orders_/$workOrderId/damage-chart'
    | '/_authenticated/work-orders_/$workOrderId/documents'
    | '/_authenticated/work-orders_/$workOrderId/items'
    | '/_authenticated/work-orders_/$workOrderId/timeline'
    | '/_authenticated/settings_/fleet/'
    | '/_authenticated/settings_/maintenance/'
    | '/_authenticated/settings_/tenant-profile/'
    | '/_authenticated/settings_/territories/'
    | '/_authenticated/vehicles_/$vehicleId/'
    | '/_authenticated/work-orders_/$workOrderId/'
    | '/_authenticated/leasing/contracts_/$contractId_/edit'
    | '/_authenticated/settings_/locations/$locationId/divisions'
    | '/_authenticated/settings_/locations/$locationId/timeslots'
    | '/_authenticated/settings_/locations/$locationId/users'
    | '/_authenticated/settings_/territories/$territoryId/customers'
    | '/_authenticated/settings_/territories/$territoryId/drivers'
    | '/_authenticated/settings_/territories/$territoryId/energy-source-prices'
    | '/_authenticated/settings_/territories/$territoryId/leasing'
    | '/_authenticated/settings_/territories/$territoryId/locations'
    | '/_authenticated/settings_/territories/$territoryId/suppliers'
    | '/_authenticated/settings_/territories/$territoryId/users'
    | '/_authenticated/vehicles_/$vehicleId_/overview/acquisition'
    | '/_authenticated/vehicles_/$vehicleId_/overview/expenses'
    | '/_authenticated/vehicles_/$vehicleId_/overview/fuel-level'
    | '/_authenticated/vehicles_/$vehicleId_/overview/insurance'
    | '/_authenticated/vehicles_/$vehicleId_/overview/maintenance'
    | '/_authenticated/vehicles_/$vehicleId_/overview/odometer'
    | '/_authenticated/vehicles_/$vehicleId_/overview/usage'
    | '/_authenticated/settings_/locations/$locationId/'
    | '/_authenticated/settings_/territories/$territoryId/'
    | '/_authenticated/vehicles_/$vehicleId_/overview/'
    | '/_authenticated/leasing/contracts_/$contractId_/agreements/$agreementId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  RTokenRoute: typeof RTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/document-test': {
      id: '/_authenticated/document-test'
      path: '/document-test'
      fullPath: '/document-test'
      preLoaderRoute: typeof AuthenticatedDocumentTestRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inspections': {
      id: '/_authenticated/inspections'
      path: '/inspections'
      fullPath: '/inspections'
      preLoaderRoute: typeof AuthenticatedInspectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/issues': {
      id: '/_authenticated/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof AuthenticatedIssuesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leasing': {
      id: '/_authenticated/leasing'
      path: '/leasing'
      fullPath: '/leasing'
      preLoaderRoute: typeof AuthenticatedLeasingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reminders': {
      id: '/_authenticated/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof AuthenticatedRemindersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vehicles': {
      id: '/_authenticated/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof AuthenticatedVehiclesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/work-orders': {
      id: '/_authenticated/work-orders'
      path: '/work-orders'
      fullPath: '/work-orders'
      preLoaderRoute: typeof AuthenticatedWorkOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/leasing/': {
      id: '/_authenticated/leasing/'
      path: '/'
      fullPath: '/leasing/'
      preLoaderRoute: typeof AuthenticatedLeasingIndexRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/leasing/analytics': {
      id: '/_authenticated/leasing/analytics'
      path: '/analytics'
      fullPath: '/leasing/analytics'
      preLoaderRoute: typeof AuthenticatedLeasingAnalyticsRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/leasing/billing': {
      id: '/_authenticated/leasing/billing'
      path: '/billing'
      fullPath: '/leasing/billing'
      preLoaderRoute: typeof AuthenticatedLeasingBillingRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/leasing/contracts': {
      id: '/_authenticated/leasing/contracts'
      path: '/contracts'
      fullPath: '/leasing/contracts'
      preLoaderRoute: typeof AuthenticatedLeasingContractsRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/leasing/leased-vehicles': {
      id: '/_authenticated/leasing/leased-vehicles'
      path: '/leased-vehicles'
      fullPath: '/leasing/leased-vehicles'
      preLoaderRoute: typeof AuthenticatedLeasingLeasedVehiclesRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/leasing/order-pipeline': {
      id: '/_authenticated/leasing/order-pipeline'
      path: '/order-pipeline'
      fullPath: '/leasing/order-pipeline'
      preLoaderRoute: typeof AuthenticatedLeasingOrderPipelineRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings_/fleet': {
      id: '/_authenticated/settings_/fleet'
      path: '/settings/fleet'
      fullPath: '/settings/fleet'
      preLoaderRoute: typeof AuthenticatedSettingsFleetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/inspections': {
      id: '/_authenticated/settings_/inspections'
      path: '/settings/inspections'
      fullPath: '/settings/inspections'
      preLoaderRoute: typeof AuthenticatedSettingsInspectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/maintenance': {
      id: '/_authenticated/settings_/maintenance'
      path: '/settings/maintenance'
      fullPath: '/settings/maintenance'
      preLoaderRoute: typeof AuthenticatedSettingsMaintenanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/tenant-profile': {
      id: '/_authenticated/settings_/tenant-profile'
      path: '/settings/tenant-profile'
      fullPath: '/settings/tenant-profile'
      preLoaderRoute: typeof AuthenticatedSettingsTenantProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/territories': {
      id: '/_authenticated/settings_/territories'
      path: '/settings/territories'
      fullPath: '/settings/territories'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/users': {
      id: '/_authenticated/settings_/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vehicles_/$vehicleId': {
      id: '/_authenticated/vehicles_/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vehicles_/add': {
      id: '/_authenticated/vehicles_/add'
      path: '/vehicles/add'
      fullPath: '/vehicles/add'
      preLoaderRoute: typeof AuthenticatedVehiclesAddRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/work-orders_/$workOrderId': {
      id: '/_authenticated/work-orders_/$workOrderId'
      path: '/work-orders/$workOrderId'
      fullPath: '/work-orders/$workOrderId'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leasing/contracts_/$contractId': {
      id: '/_authenticated/leasing/contracts_/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/leasing/contracts/$contractId'
      preLoaderRoute: typeof AuthenticatedLeasingContractsContractIdRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/leasing/contracts_/new': {
      id: '/_authenticated/leasing/contracts_/new'
      path: '/contracts/new'
      fullPath: '/leasing/contracts/new'
      preLoaderRoute: typeof AuthenticatedLeasingContractsNewRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/settings_/fleet/': {
      id: '/_authenticated/settings_/fleet/'
      path: '/'
      fullPath: '/settings/fleet/'
      preLoaderRoute: typeof AuthenticatedSettingsFleetIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/energy-sources': {
      id: '/_authenticated/settings_/fleet/energy-sources'
      path: '/energy-sources'
      fullPath: '/settings/fleet/energy-sources'
      preLoaderRoute: typeof AuthenticatedSettingsFleetEnergySourcesRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/expense-categories': {
      id: '/_authenticated/settings_/fleet/expense-categories'
      path: '/expense-categories'
      fullPath: '/settings/fleet/expense-categories'
      preLoaderRoute: typeof AuthenticatedSettingsFleetExpenseCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/vehicle-groups': {
      id: '/_authenticated/settings_/fleet/vehicle-groups'
      path: '/vehicle-groups'
      fullPath: '/settings/fleet/vehicle-groups'
      preLoaderRoute: typeof AuthenticatedSettingsFleetVehicleGroupsRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/vehicle-makes': {
      id: '/_authenticated/settings_/fleet/vehicle-makes'
      path: '/vehicle-makes'
      fullPath: '/settings/fleet/vehicle-makes'
      preLoaderRoute: typeof AuthenticatedSettingsFleetVehicleMakesRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/vehicle-models': {
      id: '/_authenticated/settings_/fleet/vehicle-models'
      path: '/vehicle-models'
      fullPath: '/settings/fleet/vehicle-models'
      preLoaderRoute: typeof AuthenticatedSettingsFleetVehicleModelsRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/vehicle-ownerships': {
      id: '/_authenticated/settings_/fleet/vehicle-ownerships'
      path: '/vehicle-ownerships'
      fullPath: '/settings/fleet/vehicle-ownerships'
      preLoaderRoute: typeof AuthenticatedSettingsFleetVehicleOwnershipsRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/fleet/vehicle-types': {
      id: '/_authenticated/settings_/fleet/vehicle-types'
      path: '/vehicle-types'
      fullPath: '/settings/fleet/vehicle-types'
      preLoaderRoute: typeof AuthenticatedSettingsFleetVehicleTypesRouteImport
      parentRoute: typeof AuthenticatedSettingsFleetRoute
    }
    '/_authenticated/settings_/locations/$locationId': {
      id: '/_authenticated/settings_/locations/$locationId'
      path: '/settings/locations/$locationId'
      fullPath: '/settings/locations/$locationId'
      preLoaderRoute: typeof AuthenticatedSettingsLocationsLocationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/maintenance/': {
      id: '/_authenticated/settings_/maintenance/'
      path: '/'
      fullPath: '/settings/maintenance/'
      preLoaderRoute: typeof AuthenticatedSettingsMaintenanceIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsMaintenanceRoute
    }
    '/_authenticated/settings_/maintenance/general': {
      id: '/_authenticated/settings_/maintenance/general'
      path: '/general'
      fullPath: '/settings/maintenance/general'
      preLoaderRoute: typeof AuthenticatedSettingsMaintenanceGeneralRouteImport
      parentRoute: typeof AuthenticatedSettingsMaintenanceRoute
    }
    '/_authenticated/settings_/maintenance/service-operations': {
      id: '/_authenticated/settings_/maintenance/service-operations'
      path: '/service-operations'
      fullPath: '/settings/maintenance/service-operations'
      preLoaderRoute: typeof AuthenticatedSettingsMaintenanceServiceOperationsRouteImport
      parentRoute: typeof AuthenticatedSettingsMaintenanceRoute
    }
    '/_authenticated/settings_/maintenance/service-plans': {
      id: '/_authenticated/settings_/maintenance/service-plans'
      path: '/service-plans'
      fullPath: '/settings/maintenance/service-plans'
      preLoaderRoute: typeof AuthenticatedSettingsMaintenanceServicePlansRouteImport
      parentRoute: typeof AuthenticatedSettingsMaintenanceRoute
    }
    '/_authenticated/settings_/tenant-profile/': {
      id: '/_authenticated/settings_/tenant-profile/'
      path: '/'
      fullPath: '/settings/tenant-profile/'
      preLoaderRoute: typeof AuthenticatedSettingsTenantProfileIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsTenantProfileRoute
    }
    '/_authenticated/settings_/tenant-profile/general': {
      id: '/_authenticated/settings_/tenant-profile/general'
      path: '/general'
      fullPath: '/settings/tenant-profile/general'
      preLoaderRoute: typeof AuthenticatedSettingsTenantProfileGeneralRouteImport
      parentRoute: typeof AuthenticatedSettingsTenantProfileRoute
    }
    '/_authenticated/settings_/tenant-profile/modules': {
      id: '/_authenticated/settings_/tenant-profile/modules'
      path: '/modules'
      fullPath: '/settings/tenant-profile/modules'
      preLoaderRoute: typeof AuthenticatedSettingsTenantProfileModulesRouteImport
      parentRoute: typeof AuthenticatedSettingsTenantProfileRoute
    }
    '/_authenticated/settings_/tenant-profile/owner': {
      id: '/_authenticated/settings_/tenant-profile/owner'
      path: '/owner'
      fullPath: '/settings/tenant-profile/owner'
      preLoaderRoute: typeof AuthenticatedSettingsTenantProfileOwnerRouteImport
      parentRoute: typeof AuthenticatedSettingsTenantProfileRoute
    }
    '/_authenticated/settings_/tenant-profile/pool-types': {
      id: '/_authenticated/settings_/tenant-profile/pool-types'
      path: '/pool-types'
      fullPath: '/settings/tenant-profile/pool-types'
      preLoaderRoute: typeof AuthenticatedSettingsTenantProfilePoolTypesRouteImport
      parentRoute: typeof AuthenticatedSettingsTenantProfileRoute
    }
    '/_authenticated/settings_/territories/': {
      id: '/_authenticated/settings_/territories/'
      path: '/'
      fullPath: '/settings/territories/'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesRoute
    }
    '/_authenticated/settings_/territories/$territoryId': {
      id: '/_authenticated/settings_/territories/$territoryId'
      path: '/$territoryId'
      fullPath: '/settings/territories/$territoryId'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesRoute
    }
    '/_authenticated/vehicles_/$vehicleId/': {
      id: '/_authenticated/vehicles_/$vehicleId/'
      path: '/'
      fullPath: '/vehicles/$vehicleId/'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdIndexRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId/acquisition': {
      id: '/_authenticated/vehicles_/$vehicleId/acquisition'
      path: '/acquisition'
      fullPath: '/vehicles/$vehicleId/acquisition'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdAcquisitionRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId/identity': {
      id: '/_authenticated/vehicles_/$vehicleId/identity'
      path: '/identity'
      fullPath: '/vehicles/$vehicleId/identity'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdIdentityRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId/insurance': {
      id: '/_authenticated/vehicles_/$vehicleId/insurance'
      path: '/insurance'
      fullPath: '/vehicles/$vehicleId/insurance'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdInsuranceRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId/options': {
      id: '/_authenticated/vehicles_/$vehicleId/options'
      path: '/options'
      fullPath: '/vehicles/$vehicleId/options'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOptionsRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId/specifications': {
      id: '/_authenticated/vehicles_/$vehicleId/specifications'
      path: '/specifications'
      fullPath: '/vehicles/$vehicleId/specifications'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdSpecificationsRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview'
      path: '/vehicles/$vehicleId/overview'
      fullPath: '/vehicles/$vehicleId/overview'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/work-orders_/$workOrderId/': {
      id: '/_authenticated/work-orders_/$workOrderId/'
      path: '/'
      fullPath: '/work-orders/$workOrderId/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRoute
    }
    '/_authenticated/work-orders_/$workOrderId/damage-chart': {
      id: '/_authenticated/work-orders_/$workOrderId/damage-chart'
      path: '/damage-chart'
      fullPath: '/work-orders/$workOrderId/damage-chart'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdDamageChartRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRoute
    }
    '/_authenticated/work-orders_/$workOrderId/documents': {
      id: '/_authenticated/work-orders_/$workOrderId/documents'
      path: '/documents'
      fullPath: '/work-orders/$workOrderId/documents'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRoute
    }
    '/_authenticated/work-orders_/$workOrderId/items': {
      id: '/_authenticated/work-orders_/$workOrderId/items'
      path: '/items'
      fullPath: '/work-orders/$workOrderId/items'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdItemsRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRoute
    }
    '/_authenticated/work-orders_/$workOrderId/timeline': {
      id: '/_authenticated/work-orders_/$workOrderId/timeline'
      path: '/timeline'
      fullPath: '/work-orders/$workOrderId/timeline'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdTimelineRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRoute
    }
    '/_authenticated/leasing/contracts_/$contractId_/edit': {
      id: '/_authenticated/leasing/contracts_/$contractId_/edit'
      path: '/contracts/$contractId/edit'
      fullPath: '/leasing/contracts/$contractId/edit'
      preLoaderRoute: typeof AuthenticatedLeasingContractsContractIdEditRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
    '/_authenticated/settings_/locations/$locationId/': {
      id: '/_authenticated/settings_/locations/$locationId/'
      path: '/'
      fullPath: '/settings/locations/$locationId/'
      preLoaderRoute: typeof AuthenticatedSettingsLocationsLocationIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLocationsLocationIdRoute
    }
    '/_authenticated/settings_/locations/$locationId/divisions': {
      id: '/_authenticated/settings_/locations/$locationId/divisions'
      path: '/divisions'
      fullPath: '/settings/locations/$locationId/divisions'
      preLoaderRoute: typeof AuthenticatedSettingsLocationsLocationIdDivisionsRouteImport
      parentRoute: typeof AuthenticatedSettingsLocationsLocationIdRoute
    }
    '/_authenticated/settings_/locations/$locationId/timeslots': {
      id: '/_authenticated/settings_/locations/$locationId/timeslots'
      path: '/timeslots'
      fullPath: '/settings/locations/$locationId/timeslots'
      preLoaderRoute: typeof AuthenticatedSettingsLocationsLocationIdTimeslotsRouteImport
      parentRoute: typeof AuthenticatedSettingsLocationsLocationIdRoute
    }
    '/_authenticated/settings_/locations/$locationId/users': {
      id: '/_authenticated/settings_/locations/$locationId/users'
      path: '/users'
      fullPath: '/settings/locations/$locationId/users'
      preLoaderRoute: typeof AuthenticatedSettingsLocationsLocationIdUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsLocationsLocationIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/': {
      id: '/_authenticated/settings_/territories/$territoryId/'
      path: '/'
      fullPath: '/settings/territories/$territoryId/'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/customers': {
      id: '/_authenticated/settings_/territories/$territoryId/customers'
      path: '/customers'
      fullPath: '/settings/territories/$territoryId/customers'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdCustomersRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/drivers': {
      id: '/_authenticated/settings_/territories/$territoryId/drivers'
      path: '/drivers'
      fullPath: '/settings/territories/$territoryId/drivers'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdDriversRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/energy-source-prices': {
      id: '/_authenticated/settings_/territories/$territoryId/energy-source-prices'
      path: '/energy-source-prices'
      fullPath: '/settings/territories/$territoryId/energy-source-prices'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/leasing': {
      id: '/_authenticated/settings_/territories/$territoryId/leasing'
      path: '/leasing'
      fullPath: '/settings/territories/$territoryId/leasing'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdLeasingRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/locations': {
      id: '/_authenticated/settings_/territories/$territoryId/locations'
      path: '/locations'
      fullPath: '/settings/territories/$territoryId/locations'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdLocationsRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/suppliers': {
      id: '/_authenticated/settings_/territories/$territoryId/suppliers'
      path: '/suppliers'
      fullPath: '/settings/territories/$territoryId/suppliers'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/settings_/territories/$territoryId/users': {
      id: '/_authenticated/settings_/territories/$territoryId/users'
      path: '/users'
      fullPath: '/settings/territories/$territoryId/users'
      preLoaderRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/'
      path: '/'
      fullPath: '/vehicles/$vehicleId/overview/'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/acquisition': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/acquisition'
      path: '/acquisition'
      fullPath: '/vehicles/$vehicleId/overview/acquisition'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewAcquisitionRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/expenses': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/expenses'
      path: '/expenses'
      fullPath: '/vehicles/$vehicleId/overview/expenses'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewExpensesRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/fuel-level': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/fuel-level'
      path: '/fuel-level'
      fullPath: '/vehicles/$vehicleId/overview/fuel-level'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewFuelLevelRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/insurance': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/insurance'
      path: '/insurance'
      fullPath: '/vehicles/$vehicleId/overview/insurance'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewInsuranceRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/maintenance': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/maintenance'
      path: '/maintenance'
      fullPath: '/vehicles/$vehicleId/overview/maintenance'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewMaintenanceRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/odometer': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/odometer'
      path: '/odometer'
      fullPath: '/vehicles/$vehicleId/overview/odometer'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewOdometerRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/vehicles_/$vehicleId_/overview/usage': {
      id: '/_authenticated/vehicles_/$vehicleId_/overview/usage'
      path: '/usage'
      fullPath: '/vehicles/$vehicleId/overview/usage'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdOverviewUsageRouteImport
      parentRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRoute
    }
    '/_authenticated/leasing/contracts_/$contractId_/agreements/$agreementId': {
      id: '/_authenticated/leasing/contracts_/$contractId_/agreements/$agreementId'
      path: '/contracts/$contractId/agreements/$agreementId'
      fullPath: '/leasing/contracts/$contractId/agreements/$agreementId'
      preLoaderRoute: typeof AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRouteImport
      parentRoute: typeof AuthenticatedLeasingRoute
    }
  }
}

interface AuthenticatedLeasingRouteChildren {
  AuthenticatedLeasingAnalyticsRoute: typeof AuthenticatedLeasingAnalyticsRoute
  AuthenticatedLeasingBillingRoute: typeof AuthenticatedLeasingBillingRoute
  AuthenticatedLeasingContractsRoute: typeof AuthenticatedLeasingContractsRoute
  AuthenticatedLeasingLeasedVehiclesRoute: typeof AuthenticatedLeasingLeasedVehiclesRoute
  AuthenticatedLeasingOrderPipelineRoute: typeof AuthenticatedLeasingOrderPipelineRoute
  AuthenticatedLeasingIndexRoute: typeof AuthenticatedLeasingIndexRoute
  AuthenticatedLeasingContractsContractIdRoute: typeof AuthenticatedLeasingContractsContractIdRoute
  AuthenticatedLeasingContractsNewRoute: typeof AuthenticatedLeasingContractsNewRoute
  AuthenticatedLeasingContractsContractIdEditRoute: typeof AuthenticatedLeasingContractsContractIdEditRoute
  AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute: typeof AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute
}

const AuthenticatedLeasingRouteChildren: AuthenticatedLeasingRouteChildren = {
  AuthenticatedLeasingAnalyticsRoute: AuthenticatedLeasingAnalyticsRoute,
  AuthenticatedLeasingBillingRoute: AuthenticatedLeasingBillingRoute,
  AuthenticatedLeasingContractsRoute: AuthenticatedLeasingContractsRoute,
  AuthenticatedLeasingLeasedVehiclesRoute:
    AuthenticatedLeasingLeasedVehiclesRoute,
  AuthenticatedLeasingOrderPipelineRoute:
    AuthenticatedLeasingOrderPipelineRoute,
  AuthenticatedLeasingIndexRoute: AuthenticatedLeasingIndexRoute,
  AuthenticatedLeasingContractsContractIdRoute:
    AuthenticatedLeasingContractsContractIdRoute,
  AuthenticatedLeasingContractsNewRoute: AuthenticatedLeasingContractsNewRoute,
  AuthenticatedLeasingContractsContractIdEditRoute:
    AuthenticatedLeasingContractsContractIdEditRoute,
  AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute:
    AuthenticatedLeasingContractsContractIdAgreementsAgreementIdRoute,
}

const AuthenticatedLeasingRouteWithChildren =
  AuthenticatedLeasingRoute._addFileChildren(AuthenticatedLeasingRouteChildren)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedSettingsFleetRouteChildren {
  AuthenticatedSettingsFleetEnergySourcesRoute: typeof AuthenticatedSettingsFleetEnergySourcesRoute
  AuthenticatedSettingsFleetExpenseCategoriesRoute: typeof AuthenticatedSettingsFleetExpenseCategoriesRoute
  AuthenticatedSettingsFleetVehicleGroupsRoute: typeof AuthenticatedSettingsFleetVehicleGroupsRoute
  AuthenticatedSettingsFleetVehicleMakesRoute: typeof AuthenticatedSettingsFleetVehicleMakesRoute
  AuthenticatedSettingsFleetVehicleModelsRoute: typeof AuthenticatedSettingsFleetVehicleModelsRoute
  AuthenticatedSettingsFleetVehicleOwnershipsRoute: typeof AuthenticatedSettingsFleetVehicleOwnershipsRoute
  AuthenticatedSettingsFleetVehicleTypesRoute: typeof AuthenticatedSettingsFleetVehicleTypesRoute
  AuthenticatedSettingsFleetIndexRoute: typeof AuthenticatedSettingsFleetIndexRoute
}

const AuthenticatedSettingsFleetRouteChildren: AuthenticatedSettingsFleetRouteChildren =
  {
    AuthenticatedSettingsFleetEnergySourcesRoute:
      AuthenticatedSettingsFleetEnergySourcesRoute,
    AuthenticatedSettingsFleetExpenseCategoriesRoute:
      AuthenticatedSettingsFleetExpenseCategoriesRoute,
    AuthenticatedSettingsFleetVehicleGroupsRoute:
      AuthenticatedSettingsFleetVehicleGroupsRoute,
    AuthenticatedSettingsFleetVehicleMakesRoute:
      AuthenticatedSettingsFleetVehicleMakesRoute,
    AuthenticatedSettingsFleetVehicleModelsRoute:
      AuthenticatedSettingsFleetVehicleModelsRoute,
    AuthenticatedSettingsFleetVehicleOwnershipsRoute:
      AuthenticatedSettingsFleetVehicleOwnershipsRoute,
    AuthenticatedSettingsFleetVehicleTypesRoute:
      AuthenticatedSettingsFleetVehicleTypesRoute,
    AuthenticatedSettingsFleetIndexRoute: AuthenticatedSettingsFleetIndexRoute,
  }

const AuthenticatedSettingsFleetRouteWithChildren =
  AuthenticatedSettingsFleetRoute._addFileChildren(
    AuthenticatedSettingsFleetRouteChildren,
  )

interface AuthenticatedSettingsMaintenanceRouteChildren {
  AuthenticatedSettingsMaintenanceGeneralRoute: typeof AuthenticatedSettingsMaintenanceGeneralRoute
  AuthenticatedSettingsMaintenanceServiceOperationsRoute: typeof AuthenticatedSettingsMaintenanceServiceOperationsRoute
  AuthenticatedSettingsMaintenanceServicePlansRoute: typeof AuthenticatedSettingsMaintenanceServicePlansRoute
  AuthenticatedSettingsMaintenanceIndexRoute: typeof AuthenticatedSettingsMaintenanceIndexRoute
}

const AuthenticatedSettingsMaintenanceRouteChildren: AuthenticatedSettingsMaintenanceRouteChildren =
  {
    AuthenticatedSettingsMaintenanceGeneralRoute:
      AuthenticatedSettingsMaintenanceGeneralRoute,
    AuthenticatedSettingsMaintenanceServiceOperationsRoute:
      AuthenticatedSettingsMaintenanceServiceOperationsRoute,
    AuthenticatedSettingsMaintenanceServicePlansRoute:
      AuthenticatedSettingsMaintenanceServicePlansRoute,
    AuthenticatedSettingsMaintenanceIndexRoute:
      AuthenticatedSettingsMaintenanceIndexRoute,
  }

const AuthenticatedSettingsMaintenanceRouteWithChildren =
  AuthenticatedSettingsMaintenanceRoute._addFileChildren(
    AuthenticatedSettingsMaintenanceRouteChildren,
  )

interface AuthenticatedSettingsTenantProfileRouteChildren {
  AuthenticatedSettingsTenantProfileGeneralRoute: typeof AuthenticatedSettingsTenantProfileGeneralRoute
  AuthenticatedSettingsTenantProfileModulesRoute: typeof AuthenticatedSettingsTenantProfileModulesRoute
  AuthenticatedSettingsTenantProfileOwnerRoute: typeof AuthenticatedSettingsTenantProfileOwnerRoute
  AuthenticatedSettingsTenantProfilePoolTypesRoute: typeof AuthenticatedSettingsTenantProfilePoolTypesRoute
  AuthenticatedSettingsTenantProfileIndexRoute: typeof AuthenticatedSettingsTenantProfileIndexRoute
}

const AuthenticatedSettingsTenantProfileRouteChildren: AuthenticatedSettingsTenantProfileRouteChildren =
  {
    AuthenticatedSettingsTenantProfileGeneralRoute:
      AuthenticatedSettingsTenantProfileGeneralRoute,
    AuthenticatedSettingsTenantProfileModulesRoute:
      AuthenticatedSettingsTenantProfileModulesRoute,
    AuthenticatedSettingsTenantProfileOwnerRoute:
      AuthenticatedSettingsTenantProfileOwnerRoute,
    AuthenticatedSettingsTenantProfilePoolTypesRoute:
      AuthenticatedSettingsTenantProfilePoolTypesRoute,
    AuthenticatedSettingsTenantProfileIndexRoute:
      AuthenticatedSettingsTenantProfileIndexRoute,
  }

const AuthenticatedSettingsTenantProfileRouteWithChildren =
  AuthenticatedSettingsTenantProfileRoute._addFileChildren(
    AuthenticatedSettingsTenantProfileRouteChildren,
  )

interface AuthenticatedSettingsTerritoriesTerritoryIdRouteChildren {
  AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute
  AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute
  AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute
  AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute
  AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute
  AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute
  AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute
  AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute
}

const AuthenticatedSettingsTerritoriesTerritoryIdRouteChildren: AuthenticatedSettingsTerritoriesTerritoryIdRouteChildren =
  {
    AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdCustomersRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdDriversRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdEnergySourcePricesRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdLeasingRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdLocationsRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdSuppliersRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdUsersRoute,
    AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdIndexRoute,
  }

const AuthenticatedSettingsTerritoriesTerritoryIdRouteWithChildren =
  AuthenticatedSettingsTerritoriesTerritoryIdRoute._addFileChildren(
    AuthenticatedSettingsTerritoriesTerritoryIdRouteChildren,
  )

interface AuthenticatedSettingsTerritoriesRouteChildren {
  AuthenticatedSettingsTerritoriesTerritoryIdRoute: typeof AuthenticatedSettingsTerritoriesTerritoryIdRouteWithChildren
  AuthenticatedSettingsTerritoriesIndexRoute: typeof AuthenticatedSettingsTerritoriesIndexRoute
}

const AuthenticatedSettingsTerritoriesRouteChildren: AuthenticatedSettingsTerritoriesRouteChildren =
  {
    AuthenticatedSettingsTerritoriesTerritoryIdRoute:
      AuthenticatedSettingsTerritoriesTerritoryIdRouteWithChildren,
    AuthenticatedSettingsTerritoriesIndexRoute:
      AuthenticatedSettingsTerritoriesIndexRoute,
  }

const AuthenticatedSettingsTerritoriesRouteWithChildren =
  AuthenticatedSettingsTerritoriesRoute._addFileChildren(
    AuthenticatedSettingsTerritoriesRouteChildren,
  )

interface AuthenticatedVehiclesVehicleIdRouteChildren {
  AuthenticatedVehiclesVehicleIdAcquisitionRoute: typeof AuthenticatedVehiclesVehicleIdAcquisitionRoute
  AuthenticatedVehiclesVehicleIdIdentityRoute: typeof AuthenticatedVehiclesVehicleIdIdentityRoute
  AuthenticatedVehiclesVehicleIdInsuranceRoute: typeof AuthenticatedVehiclesVehicleIdInsuranceRoute
  AuthenticatedVehiclesVehicleIdOptionsRoute: typeof AuthenticatedVehiclesVehicleIdOptionsRoute
  AuthenticatedVehiclesVehicleIdSpecificationsRoute: typeof AuthenticatedVehiclesVehicleIdSpecificationsRoute
  AuthenticatedVehiclesVehicleIdIndexRoute: typeof AuthenticatedVehiclesVehicleIdIndexRoute
}

const AuthenticatedVehiclesVehicleIdRouteChildren: AuthenticatedVehiclesVehicleIdRouteChildren =
  {
    AuthenticatedVehiclesVehicleIdAcquisitionRoute:
      AuthenticatedVehiclesVehicleIdAcquisitionRoute,
    AuthenticatedVehiclesVehicleIdIdentityRoute:
      AuthenticatedVehiclesVehicleIdIdentityRoute,
    AuthenticatedVehiclesVehicleIdInsuranceRoute:
      AuthenticatedVehiclesVehicleIdInsuranceRoute,
    AuthenticatedVehiclesVehicleIdOptionsRoute:
      AuthenticatedVehiclesVehicleIdOptionsRoute,
    AuthenticatedVehiclesVehicleIdSpecificationsRoute:
      AuthenticatedVehiclesVehicleIdSpecificationsRoute,
    AuthenticatedVehiclesVehicleIdIndexRoute:
      AuthenticatedVehiclesVehicleIdIndexRoute,
  }

const AuthenticatedVehiclesVehicleIdRouteWithChildren =
  AuthenticatedVehiclesVehicleIdRoute._addFileChildren(
    AuthenticatedVehiclesVehicleIdRouteChildren,
  )

interface AuthenticatedWorkOrdersWorkOrderIdRouteChildren {
  AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute: typeof AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute
  AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute: typeof AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute
  AuthenticatedWorkOrdersWorkOrderIdItemsRoute: typeof AuthenticatedWorkOrdersWorkOrderIdItemsRoute
  AuthenticatedWorkOrdersWorkOrderIdTimelineRoute: typeof AuthenticatedWorkOrdersWorkOrderIdTimelineRoute
  AuthenticatedWorkOrdersWorkOrderIdIndexRoute: typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
}

const AuthenticatedWorkOrdersWorkOrderIdRouteChildren: AuthenticatedWorkOrdersWorkOrderIdRouteChildren =
  {
    AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute:
      AuthenticatedWorkOrdersWorkOrderIdDamageChartRoute,
    AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute:
      AuthenticatedWorkOrdersWorkOrderIdDocumentsRoute,
    AuthenticatedWorkOrdersWorkOrderIdItemsRoute:
      AuthenticatedWorkOrdersWorkOrderIdItemsRoute,
    AuthenticatedWorkOrdersWorkOrderIdTimelineRoute:
      AuthenticatedWorkOrdersWorkOrderIdTimelineRoute,
    AuthenticatedWorkOrdersWorkOrderIdIndexRoute:
      AuthenticatedWorkOrdersWorkOrderIdIndexRoute,
  }

const AuthenticatedWorkOrdersWorkOrderIdRouteWithChildren =
  AuthenticatedWorkOrdersWorkOrderIdRoute._addFileChildren(
    AuthenticatedWorkOrdersWorkOrderIdRouteChildren,
  )

interface AuthenticatedSettingsLocationsLocationIdRouteChildren {
  AuthenticatedSettingsLocationsLocationIdDivisionsRoute: typeof AuthenticatedSettingsLocationsLocationIdDivisionsRoute
  AuthenticatedSettingsLocationsLocationIdTimeslotsRoute: typeof AuthenticatedSettingsLocationsLocationIdTimeslotsRoute
  AuthenticatedSettingsLocationsLocationIdUsersRoute: typeof AuthenticatedSettingsLocationsLocationIdUsersRoute
  AuthenticatedSettingsLocationsLocationIdIndexRoute: typeof AuthenticatedSettingsLocationsLocationIdIndexRoute
}

const AuthenticatedSettingsLocationsLocationIdRouteChildren: AuthenticatedSettingsLocationsLocationIdRouteChildren =
  {
    AuthenticatedSettingsLocationsLocationIdDivisionsRoute:
      AuthenticatedSettingsLocationsLocationIdDivisionsRoute,
    AuthenticatedSettingsLocationsLocationIdTimeslotsRoute:
      AuthenticatedSettingsLocationsLocationIdTimeslotsRoute,
    AuthenticatedSettingsLocationsLocationIdUsersRoute:
      AuthenticatedSettingsLocationsLocationIdUsersRoute,
    AuthenticatedSettingsLocationsLocationIdIndexRoute:
      AuthenticatedSettingsLocationsLocationIdIndexRoute,
  }

const AuthenticatedSettingsLocationsLocationIdRouteWithChildren =
  AuthenticatedSettingsLocationsLocationIdRoute._addFileChildren(
    AuthenticatedSettingsLocationsLocationIdRouteChildren,
  )

interface AuthenticatedVehiclesVehicleIdOverviewRouteChildren {
  AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute: typeof AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute
  AuthenticatedVehiclesVehicleIdOverviewExpensesRoute: typeof AuthenticatedVehiclesVehicleIdOverviewExpensesRoute
  AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute: typeof AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute
  AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute: typeof AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute
  AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute: typeof AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute
  AuthenticatedVehiclesVehicleIdOverviewOdometerRoute: typeof AuthenticatedVehiclesVehicleIdOverviewOdometerRoute
  AuthenticatedVehiclesVehicleIdOverviewUsageRoute: typeof AuthenticatedVehiclesVehicleIdOverviewUsageRoute
  AuthenticatedVehiclesVehicleIdOverviewIndexRoute: typeof AuthenticatedVehiclesVehicleIdOverviewIndexRoute
}

const AuthenticatedVehiclesVehicleIdOverviewRouteChildren: AuthenticatedVehiclesVehicleIdOverviewRouteChildren =
  {
    AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute:
      AuthenticatedVehiclesVehicleIdOverviewAcquisitionRoute,
    AuthenticatedVehiclesVehicleIdOverviewExpensesRoute:
      AuthenticatedVehiclesVehicleIdOverviewExpensesRoute,
    AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute:
      AuthenticatedVehiclesVehicleIdOverviewFuelLevelRoute,
    AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute:
      AuthenticatedVehiclesVehicleIdOverviewInsuranceRoute,
    AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute:
      AuthenticatedVehiclesVehicleIdOverviewMaintenanceRoute,
    AuthenticatedVehiclesVehicleIdOverviewOdometerRoute:
      AuthenticatedVehiclesVehicleIdOverviewOdometerRoute,
    AuthenticatedVehiclesVehicleIdOverviewUsageRoute:
      AuthenticatedVehiclesVehicleIdOverviewUsageRoute,
    AuthenticatedVehiclesVehicleIdOverviewIndexRoute:
      AuthenticatedVehiclesVehicleIdOverviewIndexRoute,
  }

const AuthenticatedVehiclesVehicleIdOverviewRouteWithChildren =
  AuthenticatedVehiclesVehicleIdOverviewRoute._addFileChildren(
    AuthenticatedVehiclesVehicleIdOverviewRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDocumentTestRoute: typeof AuthenticatedDocumentTestRoute
  AuthenticatedInspectionsRoute: typeof AuthenticatedInspectionsRoute
  AuthenticatedIssuesRoute: typeof AuthenticatedIssuesRoute
  AuthenticatedLeasingRoute: typeof AuthenticatedLeasingRouteWithChildren
  AuthenticatedRemindersRoute: typeof AuthenticatedRemindersRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedVehiclesRoute: typeof AuthenticatedVehiclesRoute
  AuthenticatedWorkOrdersRoute: typeof AuthenticatedWorkOrdersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedSettingsFleetRoute: typeof AuthenticatedSettingsFleetRouteWithChildren
  AuthenticatedSettingsInspectionsRoute: typeof AuthenticatedSettingsInspectionsRoute
  AuthenticatedSettingsMaintenanceRoute: typeof AuthenticatedSettingsMaintenanceRouteWithChildren
  AuthenticatedSettingsTenantProfileRoute: typeof AuthenticatedSettingsTenantProfileRouteWithChildren
  AuthenticatedSettingsTerritoriesRoute: typeof AuthenticatedSettingsTerritoriesRouteWithChildren
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRoute
  AuthenticatedVehiclesVehicleIdRoute: typeof AuthenticatedVehiclesVehicleIdRouteWithChildren
  AuthenticatedVehiclesAddRoute: typeof AuthenticatedVehiclesAddRoute
  AuthenticatedWorkOrdersWorkOrderIdRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRouteWithChildren
  AuthenticatedSettingsLocationsLocationIdRoute: typeof AuthenticatedSettingsLocationsLocationIdRouteWithChildren
  AuthenticatedVehiclesVehicleIdOverviewRoute: typeof AuthenticatedVehiclesVehicleIdOverviewRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDocumentTestRoute: AuthenticatedDocumentTestRoute,
  AuthenticatedInspectionsRoute: AuthenticatedInspectionsRoute,
  AuthenticatedIssuesRoute: AuthenticatedIssuesRoute,
  AuthenticatedLeasingRoute: AuthenticatedLeasingRouteWithChildren,
  AuthenticatedRemindersRoute: AuthenticatedRemindersRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedVehiclesRoute: AuthenticatedVehiclesRoute,
  AuthenticatedWorkOrdersRoute: AuthenticatedWorkOrdersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedSettingsFleetRoute: AuthenticatedSettingsFleetRouteWithChildren,
  AuthenticatedSettingsInspectionsRoute: AuthenticatedSettingsInspectionsRoute,
  AuthenticatedSettingsMaintenanceRoute:
    AuthenticatedSettingsMaintenanceRouteWithChildren,
  AuthenticatedSettingsTenantProfileRoute:
    AuthenticatedSettingsTenantProfileRouteWithChildren,
  AuthenticatedSettingsTerritoriesRoute:
    AuthenticatedSettingsTerritoriesRouteWithChildren,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRoute,
  AuthenticatedVehiclesVehicleIdRoute:
    AuthenticatedVehiclesVehicleIdRouteWithChildren,
  AuthenticatedVehiclesAddRoute: AuthenticatedVehiclesAddRoute,
  AuthenticatedWorkOrdersWorkOrderIdRoute:
    AuthenticatedWorkOrdersWorkOrderIdRouteWithChildren,
  AuthenticatedSettingsLocationsLocationIdRoute:
    AuthenticatedSettingsLocationsLocationIdRouteWithChildren,
  AuthenticatedVehiclesVehicleIdOverviewRoute:
    AuthenticatedVehiclesVehicleIdOverviewRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ActivateRoute: ActivateRoute,
  RTokenRoute: RTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
